import { Row } from '@tanstack/react-table'

interface includesPrimitiveFilterProps<T> {
    row: Row<T>
    columnId: string
    filterValue: T[]
}

export function includesPrimitiveFilter<T>({ row, columnId, filterValue }: includesPrimitiveFilterProps<T>): boolean {
    return filterValue.includes(row.getValue(columnId))
}
